import { Component, OnInit,Inject, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-viewsubadmin',
  templateUrl: './viewsubadmin.component.html',
  styleUrls: ['./viewsubadmin.component.scss']
})
export class ViewsubadminComponent implements OnInit {
  isEmited=new EventEmitter()
  createdon: any;
  email: any;
  name: any;
  phoneNo: any;
  updatedAt: any;
  constructor(private dialogRef: MatDialogRef<ViewsubadminComponent>,@Inject(MAT_DIALOG_DATA) private data:any,) { }
  ngOnInit(): void {
    this.createdon=this.data.createdAt
    this.email=this.data.email
    this.name=this.data.name
    this.updatedAt=this.data.updatedAt
    this.phoneNo=this.data.phoneNo
  }
  closeDialog() {
    this.dialogRef.close();
  }
}
